function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import PropTypes from 'prop-types';
import times from 'lodash/times';
import componentPropType from '@signal/prop-types/component';
import SkeletonTypography from '../Skeleton/Typography';
import { legacyPalette as palette } from '../Skeleton/styles';
import { Wrapper, Series, Color, Label, BadgeWrapper } from './styles';
var LabelSkeleton = Label.withComponent(SkeletonTypography);
export default function LegendSkeleton(_ref) {
  var badgeComponent = _ref.badgeComponent,
      labelComponent = _ref.labelComponent,
      marginSpacing = _ref.marginSpacing,
      seriesMarginSpacing = _ref.seriesMarginSpacing,
      numOfSeries = _ref.numOfSeries,
      rest = _objectWithoutProperties(_ref, ["badgeComponent", "labelComponent", "marginSpacing", "seriesMarginSpacing", "numOfSeries"]);

  var BadgeComponent = badgeComponent || Color;
  var LabelComponent = labelComponent || LabelSkeleton;
  return /*#__PURE__*/React.createElement(Wrapper, rest, times(numOfSeries, function (i) {
    return /*#__PURE__*/React.createElement(Series, {
      key: i,
      seriesMarginSpacing: seriesMarginSpacing
    }, /*#__PURE__*/React.createElement(BadgeWrapper, null, /*#__PURE__*/React.createElement(BadgeComponent, {
      color: palette.default.secondary,
      marginSpacing: marginSpacing
    }), /*#__PURE__*/React.createElement(LabelComponent, {
      width: 150
    })));
  }));
}
LegendSkeleton.propTypes = {
  badgeComponent: componentPropType,
  labelComponent: componentPropType,
  numOfSeries: PropTypes.number,
  marginSpacing: PropTypes.number,
  seriesMarginSpacing: PropTypes.number
};
LegendSkeleton.defaultProps = {
  numOfSeries: 2,
  marginSpacing: 1,
  seriesMarginSpacing: 4
};